export enum PlanType {
  EmailApi = 'Email API',
  MarketingCampaigns = 'Marketing Campaigns',
}
